export const LevelIcon1 = ({ width = 24, height = 24, style = {} }) => (
  <svg
    t="1758794349207"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    style={style}
  >
    <path
      d="M934.4 291.2h-291.2c-16 0-25.6 12.8-25.6 25.6v19.2H89.6c-16 0-25.6 12.8-25.6 25.6V704c0 16 12.8 25.6 25.6 25.6h841.6c16 0 25.6-12.8 25.6-25.6V316.8c3.2-12.8-9.6-25.6-22.4-25.6zM307.2 662.4c0 9.6-9.6 19.2-19.2 19.2H137.6c-9.6 0-19.2-9.6-19.2-19.2v-252.8c0-9.6 9.6-19.2 19.2-19.2h25.6c9.6 0 19.2 9.6 19.2 19.2v208h108.8c9.6 0 19.2 9.6 19.2 19.2v25.6z m272-99.2v6.4c0 6.4 0 12.8-3.2 16l-89.6 89.6c-6.4 6.4-22.4 6.4-22.4 6.4s-16 0-22.4-6.4L352 585.6c-6.4-3.2-6.4-12.8-3.2-19.2V409.6c0-9.6 9.6-19.2 19.2-19.2h25.6c9.6 0 19.2 9.6 19.2 19.2v147.2l54.4 54.4 54.4-54.4v-144c0-9.6 9.6-19.2 19.2-19.2h25.6c9.6 0 19.2 9.6 19.2 19.2v150.4z m281.6 99.2c0 9.6-9.6 19.2-19.2 19.2h-118.4c-9.6 0-19.2-9.6-19.2-19.2v-25.6c0-9.6 9.6-19.2 19.2-19.2h25.6V416h-19.2c-9.6 0-19.2-9.6-19.2-19.2v-25.6c0-9.6 9.6-19.2 19.2-19.2h64c9.6 0 19.2 9.6 19.2 19.2v243.2h25.6c9.6 0 19.2 9.6 19.2 19.2v28.8z"
      fill="#BFBFBF"
      p-id="1333"
    ></path>
  </svg>
);

export const LevelIcon2 = ({ width = 24, height = 24, style = {} }) => (
  <svg
    t="1758794459494"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    style={style}
  >
    <path
      d="M934.4 291.2h-291.2c-16 0-25.6 12.8-25.6 25.6v19.2H89.6c-16 0-25.6 12.8-25.6 25.6V704c0 16 12.8 25.6 25.6 25.6h841.6c16 0 25.6-12.8 25.6-25.6V316.8c3.2-12.8-9.6-25.6-22.4-25.6zM307.2 662.4c0 9.6-9.6 19.2-19.2 19.2H137.6c-9.6 0-19.2-9.6-19.2-19.2v-252.8c0-9.6 9.6-19.2 19.2-19.2h25.6c9.6 0 19.2 9.6 19.2 19.2v208h108.8c9.6 0 19.2 9.6 19.2 19.2v25.6z m272-99.2v6.4c0 6.4 0 12.8-3.2 16l-89.6 89.6c-6.4 6.4-22.4 6.4-22.4 6.4s-16 0-22.4-6.4L352 585.6c-6.4-3.2-6.4-12.8-3.2-19.2V409.6c0-9.6 9.6-19.2 19.2-19.2h25.6c9.6 0 19.2 9.6 19.2 19.2v147.2l54.4 54.4 54.4-54.4v-144c0-9.6 9.6-19.2 19.2-19.2h25.6c9.6 0 19.2 9.6 19.2 19.2v150.4z m326.4-38.4c0 9.6-9.6 19.2-19.2 19.2h-153.6v73.6h153.6c9.6 0 19.2 9.6 19.2 19.2v25.6c0 9.6-9.6 19.2-19.2 19.2h-198.4c-9.6 0-19.2-9.6-19.2-19.2v-163.2c0-9.6 9.6-19.2 19.2-19.2h153.6v-73.6h-153.6c-9.6 0-19.2-9.6-19.2-19.2v-25.6c0-9.6 9.6-19.2 19.2-19.2h198.4c9.6 0 19.2 9.6 19.2 19.2v163.2z"
      fill="#95DDB2"
      p-id="1485"
    ></path>
  </svg>
);

export const LevelIcon3 = ({ width = 24, height = 24, style = {} }) => (
  <svg
    t="1758794477024"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    style={style}
  >
    <path
      d="M934.4 291.2h-291.2c-16 0-25.6 12.8-25.6 25.6v19.2H89.6c-16 0-25.6 12.8-25.6 25.6V704c0 16 12.8 25.6 25.6 25.6h841.6c16 0 25.6-12.8 25.6-25.6V316.8c3.2-12.8-9.6-25.6-22.4-25.6zM307.2 662.4c0 9.6-9.6 19.2-19.2 19.2H137.6c-9.6 0-19.2-9.6-19.2-19.2v-252.8c0-9.6 9.6-19.2 19.2-19.2h25.6c9.6 0 19.2 9.6 19.2 19.2v208h108.8c9.6 0 19.2 9.6 19.2 19.2v25.6z m272-99.2v6.4c0 6.4 0 12.8-3.2 16l-89.6 89.6c-6.4 6.4-22.4 6.4-22.4 6.4s-16 0-22.4-6.4L352 585.6c-6.4-3.2-6.4-12.8-3.2-19.2V409.6c0-9.6 9.6-19.2 19.2-19.2h25.6c9.6 0 19.2 9.6 19.2 19.2v147.2l54.4 54.4 54.4-54.4v-144c0-9.6 9.6-19.2 19.2-19.2h25.6c9.6 0 19.2 9.6 19.2 19.2v150.4z m326.4 99.2c0 9.6-9.6 19.2-19.2 19.2h-198.4c-9.6 0-19.2-9.6-19.2-19.2v-25.6c0-9.6 9.6-19.2 19.2-19.2h153.6V544h-153.6c-9.6 0-19.2-9.6-19.2-19.2v-25.6c0-9.6 9.6-19.2 19.2-19.2h153.6v-73.6h-153.6c-9.6 0-19.2-9.6-19.2-19.2v-25.6c0-9.6 9.6-19.2 19.2-19.2h198.4c9.6 0 19.2 9.6 19.2 19.2v300.8z"
      fill="#92D1E5"
      p-id="1637"
    ></path>
  </svg>
);

export const LevelIcon4 = ({ width = 24, height = 24, style = {} }) => (
  <svg
    t="1758794492702"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    style={style}
  >
    <path
      d="M934.4 291.2h-291.2c-16 0-25.6 12.8-25.6 25.6v19.2H89.6c-16 0-25.6 12.8-25.6 25.6V704c0 16 12.8 25.6 25.6 25.6h841.6c16 0 25.6-12.8 25.6-25.6V316.8c3.2-12.8-9.6-25.6-22.4-25.6zM307.2 662.4c0 9.6-9.6 19.2-19.2 19.2H137.6c-9.6 0-19.2-9.6-19.2-19.2v-252.8c0-9.6 9.6-19.2 19.2-19.2h25.6c9.6 0 19.2 9.6 19.2 19.2v208h108.8c9.6 0 19.2 9.6 19.2 19.2v25.6z m272-99.2v6.4c0 6.4 0 12.8-3.2 16l-89.6 89.6c-6.4 6.4-22.4 6.4-22.4 6.4s-16 0-22.4-6.4L352 585.6c-6.4-3.2-6.4-12.8-3.2-19.2V409.6c0-9.6 9.6-19.2 19.2-19.2h25.6c9.6 0 19.2 9.6 19.2 19.2v147.2l54.4 54.4 54.4-54.4v-144c0-9.6 9.6-19.2 19.2-19.2h25.6c9.6 0 19.2 9.6 19.2 19.2v150.4z m326.4 99.2c0 9.6-9.6 19.2-19.2 19.2h-25.6c-9.6 0-19.2-9.6-19.2-19.2V544h-153.6c-9.6 0-19.2-9.6-19.2-19.2v-163.2c0-9.6 9.6-19.2 19.2-19.2h25.6c9.6 0 19.2 9.6 19.2 19.2V480h108.8v-118.4c0-9.6 9.6-19.2 19.2-19.2h25.6c9.6 0 19.2 9.6 19.2 19.2v300.8z"
      fill="#FFB37C"
      p-id="1789"
    ></path>
  </svg>
);

export const LevelIcon5 = ({ width = 24, height = 24, style = {} }) => (
  <svg
    t="1758794506451"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    style={style}
  >
    <path
      d="M934.4 291.2h-291.2c-16 0-25.6 12.8-25.6 25.6v19.2H89.6c-16 0-25.6 12.8-25.6 25.6V704c0 16 12.8 25.6 25.6 25.6h841.6c16 0 25.6-12.8 25.6-25.6V316.8c3.2-12.8-9.6-25.6-22.4-25.6zM307.2 662.4c0 9.6-9.6 19.2-19.2 19.2H137.6c-9.6 0-19.2-9.6-19.2-19.2v-252.8c0-9.6 9.6-19.2 19.2-19.2h25.6c9.6 0 19.2 9.6 19.2 19.2v208h108.8c9.6 0 19.2 9.6 19.2 19.2v25.6z m272-99.2v6.4c0 6.4 0 12.8-3.2 16l-89.6 89.6c-6.4 6.4-22.4 6.4-22.4 6.4s-16 0-22.4-6.4L352 585.6c-6.4-3.2-6.4-12.8-3.2-19.2V409.6c0-9.6 9.6-19.2 19.2-19.2h25.6c9.6 0 19.2 9.6 19.2 19.2v147.2l54.4 54.4 54.4-54.4v-144c0-9.6 9.6-19.2 19.2-19.2h25.6c9.6 0 19.2 9.6 19.2 19.2v150.4z m326.4-172.8c0 9.6-9.6 19.2-19.2 19.2h-153.6V480h153.6c9.6 0 19.2 9.6 19.2 19.2v163.2c0 9.6-9.6 19.2-19.2 19.2h-198.4c-9.6 0-19.2-9.6-19.2-19.2v-25.6c0-9.6 9.6-19.2 19.2-19.2h153.6V544h-153.6c-9.6 0-19.2-9.6-19.2-19.2v-163.2c0-9.6 9.6-19.2 19.2-19.2h198.4c9.6 0 19.2 9.6 19.2 19.2v28.8z"
      fill="#FF6C00"
      p-id="1941"
    ></path>
  </svg>
);
